import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import type {
  SkillsImportChangeCounts,
  SkillsImportMessageGroups,
  SkillsImportResult,
} from '@core/tellent-skills-types';

@Injectable({ providedIn: 'root' })
export class SkillsImportSummaryService {
  private readonly sanitizer = inject(DomSanitizer);

  public countChanges(result: SkillsImportResult | null | undefined): SkillsImportChangeCounts {
    const skills = result?.skills ?? [];
    const positions = result?.positions ?? [];

    return {
      newSkills: skills.filter(skill => skill.matchedSkillId === null).length,
      existingSkills: skills.filter(skill => skill.matchedSkillId !== null).length,
      newPositions: positions.filter(position => position.existingPositionGuid === null).length,
      existingPositions: positions.filter(position => position.existingPositionGuid !== null)
        .length,
    };
  }

  public groupMessages(result: SkillsImportResult | null | undefined): SkillsImportMessageGroups {
    const messages = result?.messages ?? [];
    const sanitized = messages.map(message => ({
      ...message,
      sanitizedText: this.sanitizer.sanitize(SecurityContext.HTML, message.text) ?? '',
    }));

    return {
      positiveAndInfo: sanitized.filter(
        message => message.type === 'positive' || message.type === 'info',
      ),
      warning: sanitized.filter(message => message.type === 'warning'),
      blockingError: messages.filter(message => message.type === 'blocking_error'),
    };
  }
}
